import { render, staticRenderFns } from "./applyFinish.vue?vue&type=template&id=2db502e5&scoped=true&"
import script from "./applyFinish.vue?vue&type=script&lang=js&"
export * from "./applyFinish.vue?vue&type=script&lang=js&"
import style0 from "./applyFinish.vue?vue&type=style&index=0&id=2db502e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db502e5",
  null
  
)

export default component.exports